import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

export const HideRunSetsIcon: typeof Icon = styled(Icon)`
  font-size: 28px;
  padding: 2px 0 0 4px;
  color: light-dark(${globals.gray500}, var(--moon-500));
  cursor: pointer;
  &:hover {
    color: light-dark(darken(${globals.gray500}, 12%), var(--moon-350));
  }
`;
